import React, {} from "react"

export default function UpgradeProcessPost(res) {
    //  close the popups
    window.location.assign('/' + res.data.influencer)
}
